/**
 * Arquivo de reducer para o Token.
 * Gerencia o estado relacionado ao Token na aplicação.
 * Utiliza Redux para atualizar o estado com base nas ações despachadas.
 */

const estadoInicial = {
  access_token: "",
  expires_in: "",
  refresh_token: "",
  token_type: "",
};
// eslint-disable-next-line
export default function (state = estadoInicial, action: any) {
  switch (action.type) {
    case "ALTERA_TOKEN":
      return {
        ...state,
        access_token: action.payload.access_token,
        expires_in: action.payload.expires_in,
        refresh_token: action.payload.refresh_token,
        token_type: action.payload.token_type,
      };
    default:
      return {
        ...state,
      };
  }
}
